import qs from 'query-string';
import { getPageProps } from '@kibt/krn-utils';
import { getEnv, getKrnDomain } from '../api';
import queryString from 'query-string';
import { abPromise } from '@/store/useAbStore';

export async function parseSearchUrl(url: string) {
    const _url = queryString.parseUrl(url).url;
    if (!_url.includes('/shop/c/search')) return url;
    const ab = await abPromise;

    if (!ab?.if_krn_shop_search_fe || !ab?.if_krn_shop_search_fe?.value) {
        return url;
    }

    const { query } = qs.parseUrl(url);
    const krnUrl = qs.stringify({
        bundleId: 'EcommShopSearch',
        componentName: 'Search',
        env: getEnv(),
    });
    return qs.stringifyUrl({
        url: `${getKrnDomain()}/shop/c/search`,
        query: {
            krnFollowParams: 1,
            env: getEnv(),
            ...query,
            fromBundle: getPageProps().bundleId,
            source: getPageProps().bundleId,
            // initialRouteName: 'Search',
            hyId: 'kibt-fe-shop-c-v1',
            __launch_options__: JSON.stringify({
                topBarPosition: 'fixed',
            }),
            redirectUrl: krnUrl,
        },
    });
}
